/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';

// reactstrap components
import {
  Spinner,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Alert,
} from 'reactstrap';
// core components
import utils from '../utils.js';

class Webhook extends React.Component {
  constructor(props) {
    super(props);
    this.formOnChange = this.formOnChange.bind(this);
    this.state = {
      webhookUrl: null,
      touched: false,
      saving: false,
      loading: false,
    };
  }

  async componentDidMount() {
    this.setState({
      webhookUrl: this.props.user && this.props.user.discordWebhook,
    });
  }

  handleSave = async () => {
    this.setState({
      saving: true,
      errorMessage: null,
    });

    const { webhookUrl } = this.state;

    if (!webhookUrl) {
      this.setState({
        saving: false,
        errorMessage: 'Webhook URL must not be empty!',
      });
      return;
    }

    const { success, errorMessage } = await utils.putWebhook(webhookUrl);
    if (success) {
      this.setState({
        touched: false,
        saving: false,
      });
      await this.props.updateUser();
    } else {
      this.setState({
        errorMessage,
        saving: false,
      });
    }
  };

  renderSaveButton = () => {
    const color = this.state.touched ? 'warning' : 'primary';
    const spinner = <Spinner className="ml-1" size="sm" color="warning" />;
    const saveButton = (
      <Button
        disabled={!this.state.touched}
        color={color}
        size="lg"
        type="button"
        className="ml-3"
        onClick={this.handleSave}
      >
        Save Changes
      </Button>
    );
    return (
      <>
        {this.state.loading ? null : saveButton}
        {this.state.saving ? spinner : null}
      </>
    );
  };

  async formOnChange(e) {
    const inputName = e.target.name;
    const inputValue = e.target.value;
    this.setState({
      [inputName]: inputValue,
      touched: true,
    });
  }

  renderErrors() {
    if (this.state.errorMessage) {
      return <Alert color="danger">{this.state.errorMessage}</Alert>;
    }
  }

  render() {
    let webhookUrl;
    if (this.state.touched) {
      webhookUrl = this.state.webhookUrl;
    } else {
      webhookUrl =
        this.state.webhookUrl ||
        (this.props.user && this.props.user.discordWebhook) ||
        '';
    }
    return (
      <>
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="8">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">
                        Notification Setup
                        {this.state.loading ? (
                          <Spinner className="ml-1" size="sm" color="warning" />
                        ) : null}
                      </h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {this.renderErrors()}
                  <Form>
                    <h5 className="mb-4">
                      <div className="heading-small text-muted">
                        Discord Webhook
                      </div>
                      <div>
                        You must create a Discord webhook in a personal Discord
                        channel so you can receive notifications when the bot
                        purchases an item or has issues.{' '}
                        <a
                          href="https://docs.snailbot.io/notifications"
                          target="_blank"
                        >
                          Follow this guide
                        </a>{' '}
                        to set up your webhook.
                      </div>
                    </h5>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Discord Webhook URL
                            </label>
                            <Input
                              name="webhookUrl"
                              value={webhookUrl}
                              className="form-control-alternative"
                              id="input-email"
                              placeholder="https://discord.com/api/webhooks/123456789/XXXXXXXXXXXXXXXXXXXX"
                              type="text"
                              onChange={this.formOnChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    <div className="pl-lg-4">
                      <Row>{this.renderSaveButton()}</Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Webhook;
